<template>
  <v-card class="pa-8">
    <v-row column>
      <v-col class="pa-3">
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row>
            <v-col cols="12">
              <SiteSelect
                :site="isEdit ? video.site_key : $attrs.site_key"
                @site-selected="siteSelected"
                input
              ></SiteSelect>
            </v-col>
          </v-row>
          <v-row row justify-center>
            <v-col lg8>
              <v-text-field
                label="Название"
                required
                :rules="notEmptyRules"
                v-model="video.title"
                type="text"
                name="title"
              ></v-text-field>
              <v-textarea
                v-model="video.description"
                label="Описание"
                counter
                maxlength="250"
                single-line
                name="description"
              ></v-textarea>
              <v-text-field
                v-model="video.url"
                label="Ссылка на VK Video"
                counter
                maxlength="250"
                single-line
                name="url"
                :rules="[vkVideoRule]"
              ></v-text-field>
              <v-col xs12 sm6 md4>
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="datDisplay"
                      label="Дата публикации"
                      prepend-icon="event"
                      readonly
                      name="date"
                      :rules="notEmptyRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" locale="ru-ru" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu = false">Отменить </v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu.save(date)"> Выбрать </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-switch label="Опубликован" v-model="video.published"></v-switch>
              <v-switch label="Во в кладку 'Фильмы'" v-model="video.is_movie"></v-switch>
              <v-k-video v-if="isVk" :link="video.url"></v-k-video>
              <youtube
                v-if="isYouTube && getVideoId(video.url)"
                player-height="350"
                player-width="100%"
                :video-id="getVideoId(video.url)"
              >
              </youtube>
              <v-col aling-self-right>
                <v-btn @click="save" color="primary">Сохранить</v-btn>
                <v-btn @click="remove" color="warning">Удалить</v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog v-model="infoDialog" max-width="500px" persistent>
      <v-card class="ma-auto">
        <v-card-title class="text-center">
          <div class="ma-auto">Обращаем ваше внимание</div>
        </v-card-title>
        <v-card-text>
          <p>
            В связи с проблемами работы YouTube на территории РФ, ссылки на этот ресурс более не
            принимаются. Просим вас использовать для видео контента VK Video.
          </p>
          <p>
            Также, для корректной работы видеоплеера, необходимо использовать
            <strong>НЕ</strong> прямую ссылку на видео, а ссылку, которую можно получить следующим
            образом: откройте видео в плеере и нажмите на кнопку <strong>Экспортировать</strong>. В
            появившемся окне скопируйте ссылку, которая находится в части кода с
            <strong>iframe</strong> в атрибуте <strong>src</strong>.
          </p>
          <p>
            Пример: <br />
            <code>
              &lt;iframe src="https://vk.com/video_ext.php?oid=-22822305&id=456241864&hd=2"
              width="853" height="480" allow="autoplay; encrypted-media; fullscreen;
              picture-in-picture;" frameborder="0" allowfullscreen&gt;&lt;/iframe&gt;
            </code>
            <br />
            Ссылка - <strong>https://vk.com/video_ext.php?oid=-22822305&id=456241864&hd=2</strong>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="infoDialog = false" color="primary">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import api from '@/mixins/api'
import SiteSelect from '@/components/SiteSelect'
import utils from '@/mixins/utils'
import VKVideo from '@/components/VKVideo.vue'

const moment = require('moment')

export default {
  name: 'video_albums_create',
  components: { VKVideo, SiteSelect },
  mixins: [api, utils],
  data() {
    return {
      infoDialog: true,
      dateMenu: false,
      siteKey: '',
      date: moment().format('YYYY-MM-DD'),
      video: {
        id: -1,
        title: '',
        description: '',
        url: '',
        kind: 'vk',
        published: false,
        is_movie: false,
        site_key: '',
        video: '',
      },
      valid: true,
      notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
    }
  },
  computed: {
    datDisplay() {
      return moment(this.date).locale('ru').format('LL')
    },
    isEdit() {
      return !!this.$route.params.id
    },
    isYouTube() {
      return this.video.url.includes('https://youtu')
    },
    isVk() {
      return this.video.url.includes('https://vk')
    },
  },
  watch: {
    date(e) {
      this.video.date = moment(e).add(12, 'hours').format()
    },
    '$route.params.site_key': function () {
      this.video.site_key = this.$route.params.site_key
    },
    '$attrs.site_key': function () {
      this.video.site_key = this.$attrs.site_key
    },
    '$attrs.title': function () {
      // this.site = this.$route.params.site_key
    },
  },
  mounted() {
    if (this.isEdit) {
      this.axios({
        method: 'get',
        url: `/v1/media/videos/${this.$route.params.id}`,
      })
        .then((resp) => {
          this.video = resp.data
          this.date = moment(this.video.date).format('YYYY-MM-DD')
        })
        .catch((err) => {
          this.$log.error('get video', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    }
  },
  methods: {
    siteSelected(e) {
      this.video.site_key = e.key
    },
    vkVideoRule(v) {
      return (!!v && this.isVk) || 'Только VK Video'
    },
    save() {
      // const formData = new FormData(document.forms.form)
      this.axios({
        url: this.isEdit ? `/v1/media/videos/${this.video.id}` : '/v1/media/videos',
        method: this.isEdit ? 'patch' : 'post',
        data: this.video,
      })
        .then((resp) => {
          this.video = resp.data
          this.showSnackbar('Сохранено', 'green')
          if (!this.isEdit) {
            this.$router.push({
              name: 'video_albums_edit',
              params: { id: this.video.id },
            })
          }
        })
        .catch((err) => {
          this.$log.error('video create err', err)
          this.showSnackbar(err.toString(), 'error')
        })
    },
    remove() {
      // const formData = new FormData(document.forms.form)
      this.axios({
        url: `/v1/media/videos/${this.video.id}`,
        method: 'delete',
      })
        .then((resp) => {
          this.$router.push({ name: 'video_albums_list' })
          this.showSnackbar('Удалено', 'green')
        })
        .catch((err) => {
          this.$log.error('video create err', err)
          this.showSnackbar(err.toString(), 'error')
        })
    },
  },
}
</script>
